import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import { Cookie } from '../../utils/cookie';
import { TmErrorInfo } from '../model/error';
import { TmGiftCardRequest } from '../model/request/account_cart-request';

import { ApiBase } from './apibase.service';


export class GiftCardBalance extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    /** @description Returns balance left on a given giftcard
     *   @return {string}
     */
    private giftcardBalanceUrl = this.baseUrl + '/giftcardbalance';

    post(gcBalanceReq: TmGiftCardRequest): Observable<string> {
        const cookie = new Cookie();
        return this.getAppToken()
            .map((tokenResp) => tokenResp)
            .flatMap((accessToken) => {
                return this.http
                    .post(this.giftcardBalanceUrl, gcBalanceReq, { headers: this.appTokenJsonTypeHeader })
                    .map((balanceData) => balanceData.json() as string)
                    .catch((balanceResp) => {
                        if (balanceResp.status === 401) {
                            return this.createAppToken()
                                .flatMap((token) => {
                                    cookie.AppToken = token.json().access_token;
                                    return this.http
                                        .post(this.giftcardBalanceUrl, gcBalanceReq, {
                                            headers: this.appTokenJsonTypeHeader,
                                        })
                                        .catch((secondCallError) => {
                                            if (secondCallError.status === 417) {
                                                const secondErrorInfo: TmErrorInfo = (
                                                    secondCallError.json() as TmErrorInfo[]
                                                )[0];
                                                return Observable.throw(secondErrorInfo.Message);
                                            } else {
                                                return Observable.throw(secondCallError.json());
                                            }
                                        });
                                })
                                .map((balanceData) => balanceData.json() as string);
                        } else if (balanceResp.status === 417) {
                            const errorInfo: TmErrorInfo = (balanceResp.json() as TmErrorInfo[])[0];
                            return Observable.throw(errorInfo.Message);
                        } else {
                            return Observable.throw(balanceResp.json());
                        }
                    });
            });
    }
}(GiftCardBalance as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/giftcard.service.ts